import { render, staticRenderFns } from "./OperatorDataUpdate.vue?vue&type=template&id=2cb5af19&scoped=true"
import script from "./OperatorDataUpdate.vue?vue&type=script&lang=js"
export * from "./OperatorDataUpdate.vue?vue&type=script&lang=js"
import style0 from "./OperatorDataUpdate.vue?vue&type=style&index=0&id=2cb5af19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5af19",
  null
  
)

export default component.exports